import { createSelector } from '@reduxjs/toolkit';

import { RootState } from 'types';
import { initialState } from '.';

const selectSlice = (state: RootState) => state.updateAdvisor || initialState;

export const selectUpdateAdvisor = createSelector(
  [selectSlice],
  state => state,
);
